import threadApi from '@/api/thread.api'
import emailApi from '@/api/email.api'
import fileApi from '@/api/file.api'
import { fileType } from '@/constants'

const state = {
  threads: [],
  threadTotalCount: 0,
  threadEmails: [],
  threadEmailsTotalCount: 0,
  allThreads: []
}

const getters = {
  searchSuggestions: (state) => {
    return state.allThreads.map(x => x.subject)
  }
}

const actions = {
  async loadThreads ({ commit, rootState }, { onlyThisProject, skip, take, search }) {
    const response = await threadApi.getThreads(rootState.tenant.current, rootState.project.currentId, onlyThisProject, skip, take, search)
    commit('SET_THREADS', { threads: response.data, count: parseInt(response.headers['x-total-count']) })
  },

  async loadAllThreads ({ commit, rootState }, onlyThisProject) {
    const response = await threadApi.getThreads(rootState.tenant.current, rootState.project.currentId, onlyThisProject)
    commit('SET_ALL_THREADS', response.data)
  },

  async loadThreadEmails ({ commit, dispatch, rootState }, { projectId, threadId, userEmail, skip, take }) {
    const response = await threadApi.getThreadEmails(rootState.tenant.current, projectId, threadId, skip, take)
    const notReadEmails = response.data.emails
      .filter(e => !e.outgoing && e.readUsers && e.readUsers.filter(u => u.email === userEmail).length === 0)
      .map(email => {
        return {
          id: email.id
        }
      })
    notReadEmails.forEach(async (e) => await dispatch('readEmail', e.id))
    commit('SET_THREAD_EMAILS', { thread: response.data, count: parseInt(response.headers['x-total-count']) })
  },

  async createThread ({ commit, dispatch, rootState }, thread) {
    const projectId = rootState.project.currentId
    const response = await threadApi.createThread(rootState.tenant.current, projectId, thread.email)
    commit('CREATE_THREAD', { thread: response.data, projectId: projectId })
    thread.emailId = response.data.id
    // await dispatch('createAttachments', thread)
  },

  async sendEmail ({ commit, dispatch, rootState }, thread) {
    const response = await emailApi.createEmail(rootState.tenant.current, thread.email)
    commit('CREATE_EMAIL', { email: response.data })
    thread.emailId = response.data.id
    // await dispatch('createAttachments', thread)
  },

  async createAttachments ({ rootState }, attachments) {
    const projectId = rootState.project.currentId
    const result = []
    for (let i = 0; i < attachments.length; i++) {
      const attachment = attachments[i]
      const response = await fileApi.uploadFile(rootState.tenant.current, projectId, fileType.emailAttachment, attachment)
      result.push(response.data)
    }
    return result
  },

  async getEmail ({ commit, rootState }, emailId) {
    return await emailApi.getEmail(rootState.tenant.current, emailId)
  },

  async readEmail ({ commit, rootState }, emailId) {
    return await emailApi.readEmail(rootState.tenant.current, emailId)
  },

  async getAttachment ({ commit, rootState }, attachment) {
    return await emailApi.getAttachment(rootState.tenant.current, attachment.emailId, attachment.id)
  }
}

const mutations = {
  SET_THREADS (state, { threads, count }) {
    state.threads = threads
    state.threadTotalCount = count
  },

  SET_ALL_THREADS (state, data) {
    state.allThreads = data
  },

  SET_THREAD_EMAILS (state, { thread, count }) {
    state.threadEmails = thread.emails
    state.threadEmails.unshift(thread)
    state.threadEmailsTotalCount = count + 1
  },

  CREATE_THREAD (state, { thread, projectId }) {
    thread.projectId = projectId
    thread.active = false
    state.threads.unshift(thread)
    state.threadTotalCount += 1
  },

  CREATE_EMAIL (state, { email }) {
    email.to = email.to.map(contact => {
      return {
        contactId: null,
        email: contact,
        name: contact
      }
    })
    email.from = {
      email: email.from,
      name: email.from
    }
    state.threadEmails.push(email)
    state.threadEmailsTotalCount += 1
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
